<script>
	export default {
		name: 'CsvExecuter',
		methods: {
			getCsvHeader(data) {
				const self_ = this;
				const rows_ = data.replace(/\r?\n/g, '__split__').split('__split__')
				return rows_[0].split(',')
			},
			getCsvRows(data) {
				const self_ = this;
				let rows_ = data.replace(/\r?\n/g, '__split__').split('__split__')
				// remove header row
				rows_.shift()

				let result_ = []
				rows_.forEach(row => {
					if(row) { result_.push(row.split(',')) }
				})
				return result_
			},
			checkCsvFormat(header) {
				const self_ = this;

				const data_ = self_.getInputState('data')

				let header_ = []
				data_.header.forEach(item => header_.push(item.text))

				return header_.length == header.length && header_.join(',') == header.join(',')
			},
			$_csvExec_addCsvRows(docId, key, value) {
				const self_ = this;
				return self_.setFirestoreSubDocument('csvs', docId, 'rows', key, value)
			}
		}
	}
</script>	